import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(theme => ({
  form: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(3)
  },
  widthPercentage: {
    width: '55%'
  },
  formHeading: {
    marginLeft: theme.spacing(2),
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700,
    fontSize: '26px',
    lineHeight: '30px',
    letterSpacing: '0.4px',
    verticalAlign: 'middle',
    color: '#000000'
  },
  headingInstruction: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: '#333333',
    paddingRight: theme.spacing(2)
  },
  instructionLink: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: '#005596',
    textTransform: 'uppercase'
  },
  sectionHeader: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: '#000000DE'
  },
  inputTextField: {
    width: '55%',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    color: '#0000008A',
    height: '40px',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px'
  },
  inputSelectField: {
    width: '55%',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    color: '#0000008A',
    height: '40px',
    borderRadius: '4px'
  },
  inputTextAreaField: {
    width: '55%',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '12px',
    letterSpacing: '0px',
    color: '#000000'
  },
  radioGroupField: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: '#000000DE',
    '& legend': {
      color: 'inherit',
      fontWeight: 500
    }
  },
  attachmentText: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: '#000000DE'
  },
  checkboxField: {
    Width: '20px',
    Height: '20px'
  },
  checkboxTextField: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: '#000000DE',
    verticalAlign: 'middle'
  },
  checkboxLinkTextField: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: '#005596',
    textTransform: 'uppercase',
    verticalAlign: 'middle'
  },
  unorderedList: {
    margin: 0,
    paddingLeft: '25px'
  },
  textColor: {
    color: '#0009'
  },
  countryDropdownPrintOnly: {
    '@media print': {
      minWidth: '40% !important'
    }
  },
  noPrint: {
    '@media print': {
      display: 'none'
    }
  },
  noBreakPrintOnly: {
    breakInside: 'avoid',
    pageBreakInside: 'avoid'
  },
  createdAtField: {
    fontSize: '0.75rem',
    fontWeight: 700,
    color: theme.palette.text.primary
  },
  createdAtFieldValue: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: theme.palette.text.secondary
  }
}))
